(function(){
'use strict';

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

angular.module('classy').component('scSupporterNav', {
  templateUrl: 'frs/shared/supporter/components/scSupporterNav/template',
  bindings: {
    textColor: '<'
  },
  controller: ["$state", "$element", "$timeout", "scFundraisingTeamsService", "scFundraisingPagesService", "scMembersService", "scCampaignsService", "scThemesService", "scAuth", "scPageAccessService", "scSupporterNavService", "accessibilityService", function controller($state, $element, $timeout, scFundraisingTeamsService, scFundraisingPagesService, scMembersService, scCampaignsService, scThemesService, scAuth, scPageAccessService, scSupporterNavService, accessibilityService) {
    var _this = this;

    // Each time the scMembersService initializes, we want it to call this registered callback.
    // This will establish wether or not the member viewing the page or team has access to
    // manage it or not, as specified in the serCurrentPage logic
    scMembersService.registerInitCallback(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return scAuth.checkStatus().then(function () {
                return scPageAccessService.sync().then(function () {
                  _this.setCurrentPage();
                });
              });

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    })));

    /* Lifecycle
    ========================================================= */
    this.$onInit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              this.handleClickOutside();
              _context2.next = 3;
              return this.setCurrentPage();

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    /* Properties
    ========================================================= */
    this.theme = scThemesService.active.current;
    this.isDropdownOpen = false;
    this.target = $state.current.name.includes('frs.landing.name.campaign.registration') ? '_blank' : '_self';

    /* Public Methods
    ========================================================= */
    this.onDashboard = function () {
      return $state.current.name.includes('dashboard');
    };
    this.onPreviewPage = function () {
      return $state.params.preview;
    };
    this.toggleDropdownOpen = function () {
      this.isDropdownOpen = !this.isDropdownOpen;
      if (this.isDropdownOpen) {
        accessibilityService.initiatePageFocus('.supporter-dashboard-nav_dropdown-menu');
      } else {
        accessibilityService.initiatePageFocus('.supporter-dashboard-nav_dropdown-toggle');
      }
    };

    /* Pagination Methods
    ========================================================= */
    this.getFundraisingTeams = function () {
      return scSupporterNavService.getFundraisingTeams();
    };
    this.getFundraisingPages = function () {
      return scSupporterNavService.getFundraisingPages();
    };
    this.canLoadMoreTeams = function () {
      return scSupporterNavService.canLoadMoreTeams();
    };
    this.canLoadMorePages = function () {
      return scSupporterNavService.canLoadMorePages();
    };
    this.loadMoreTeams = function () {
      return scSupporterNavService.loadMoreTeams();
    };
    this.loadMoreFundraisingPages = function () {
      return scSupporterNavService.loadMoreFundraisingPages();
    };
    this.fundraisingPagesCount = function () {
      return _this.getFundraisingPages().length;
    };
    this.fundraisingTeamsCount = function () {
      return _this.getFundraisingTeams().length;
    };

    /**
     * Function determining whether the member has multiple
     * pages associated with this campaign. Used to
     * show/hide the dropdown menu.
     *
     * @return {boolean} Should the dropdown be shown?
     */
    this.showPagesDropdown = function () {
      var showPagesDropdown = false;

      if (!_.isEmpty(scMembersService.you.current)) {
        var userPages = _.size(scFundraisingPagesService.userFundraisers);
        var userTeams = _.size(scFundraisingTeamsService.userTeams);
        if (userTeams || userPages) {
          showPagesDropdown = true;
          var pageType = this.pageType;
          if (pageType == 'fundraiser' || pageType == 'team') {
            var onUsersFundraiserPage = !!_.get(scFundraisingPagesService, 'userFundraisers[' + _.get(scFundraisingPagesService, 'active.current.id', 0) + ']', false);
            var onUsersTeamPage = !!_.get(scFundraisingTeamsService, 'userTeams[' + _.get(scFundraisingTeamsService, 'active.current.id', 0) + ']', false);
            if (userPages == 1 && userTeams == 0 && onUsersFundraiserPage) {
              showPagesDropdown = false;
            } else if (userTeams == 1 && userPages == 0 && onUsersTeamPage) {
              showPagesDropdown = false;
            }
          }
        }
      }

      return showPagesDropdown;
    };

    /**
     * Toggles state to the current page's dashboard
     */
    this.goToDashboard = function () {
      $state.go(this.dashboardLink);
    };

    /**
     * Toggles state to the current page's public view
     */
    this.goToPage = function () {
      $state.go(this.pageLink);
    };

    /**
     * Style for manage toggle button
     * and supporter dropdown.
     *
     * @return {object} AngularJS ng-style object
     */
    this.buttonStyle = function () {
      return {
        color: this.textColor,
        borderColor: this.textColor
      };
    };

    this.handleClickOutside = function () {
      angular.element('body').on('click', function (event) {
        if (!_this.isDropdownOpen) {
          return;
        }

        if ($element.find(event.target).length > 0) {
          return;
        }

        $timeout(function () {
          _this.isDropdownOpen = false;
        });
      });
    };

    /**
     * Fetch logo url for fundraiser and team
     *
     * @example Usage: getLogoSrc(page, 'fundraiser') OR getLogoSrc(page, 'team')
     *
     * @param page {object}
     * @param pagetType {string}
     * @return Url of logo for requested resource {string}.
     */
    this.getLogoSrc = function (page, pageType) {
      if (pageType === 'fundraiser') {
        return scFundraisingPagesService.getPagePhoto(page);
      } else if (pageType === 'team') {
        return scFundraisingTeamsService.getTeamPhoto(page);
      }

      return '/static/global/images/individual_default_image.png';
    };

    /**
     * Determines which page is currently active.
     * Normalizes the page "name" and links.
     *
     * @return {object} An object representing the current page.
     */
    this.setCurrentPage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!$state.current.name.includes('fundraiser')) {
                _context3.next = 10;
                break;
              }

              _this.pageType = 'fundraiser';
              _this.currentPage = scFundraisingPagesService.active.current;
              _this.dashboardLink = 'frs.fundraiser.dashboardindex.dashboard.overview';
              _context3.next = 6;
              return scFundraisingPagesService.active.checkDashboardAccess(_this.pageType);

            case 6:
              _this.canManage = _context3.sent;

              _this.pageLink = 'frs.fundraiser.index';
              _context3.next = 21;
              break;

            case 10:
              if (!($state.current.name.includes('team') && !$state.current.name.includes('create-fundraising-team'))) {
                _context3.next = 20;
                break;
              }

              _this.pageType = 'team';
              _this.currentPage = scFundraisingTeamsService.active.current;
              _this.dashboardLink = 'frs.team.dashboardindex.dashboard.overview';
              _context3.next = 16;
              return scFundraisingTeamsService.active.checkDashboardAccess(_this.pageType);

            case 16:
              _this.canManage = _context3.sent;

              _this.pageLink = 'frs.team.index';
              _context3.next = 21;
              break;

            case 20:
              if ($state.current.name.includes('donation')) {
                _this.pageType = 'donation';
              } else {
                _this.pageType = 'campaign';
                _this.currentPage = scCampaignsService.active.current;
              }

            case 21:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));
  }]
});
})();